import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=626c55e0&scoped=true"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c55e0",
  null
  
)

export default component.exports